<div>
  @if (darkModeStore.isActive()) {
    <aw-button
      [id]="'light-mode-toogle'"
      [type]="'button'"
      [style]="'primary-alt'"
      (click)="setDarkModeValue(false)"
      [buttonSize]="'quadratic'">
      <span class="material-symbols-rounded icon-filled">light_mode</span>
    </aw-button>
  } @else {
    <aw-button
      [id]="'dark-mode-toggle'"
      [type]="'button'"
      [style]="'primary-alt'"
      (click)="setDarkModeValue(true)"
      [buttonSize]="'quadratic'">
      <span class="material-symbols-rounded icon-filled">dark_mode</span>
    </aw-button>
  }
</div>
